import { EmptyComponent } from "../../components/common/EmptyComponent";
import Loadable from "react-loadable";
import PropTypes from "prop-types";
import React from "react";
import { UserContextSelectors } from "../../redux/selectors";
import { useSelector } from "react-redux";
import { ClientProviderUtils } from "../../utils/clientProviderUtils";

const getRegulationLogosSection = (
  brandId,
  trackingInfo,
  showControlCenter
) => {
  const sportProvider = ClientProviderUtils.getClientProvider();

  try {
    const RegulationLogosSection = Loadable({
      loader: () =>
        import(
          /* webpackChunkName: "[request]" */

          `../Brands/${brandId}/${sportProvider}/RegulationLogosSection.layout`
        ),
      loading: EmptyComponent
    });

    return (
      RegulationLogosSection && (
        <RegulationLogosSection
          trackingInfo={trackingInfo}
          showControlCenter={showControlCenter}
        />
      )
    );
  } catch {
    return null;
  }
};

const RegulationLogosSection = ({ trackingInfo, showControlCenter }) => {
  const brandId = useSelector(UserContextSelectors.brandId);
  return getRegulationLogosSection(brandId, trackingInfo, showControlCenter);
};

RegulationLogosSection.propTypes = {
  brandId: PropTypes.number,
  trackingInfo: PropTypes.object,
  showControlCenter: PropTypes.bool
};

export default React.memo(RegulationLogosSection);
